// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__X5dLf","location":"Header_location__Rkwq-"};